export class ZoneTypeModel {
  constructor(id, name, markerIconUri) {
    this.id = id;
    this.name = name;
    this.markerIconUri = markerIconUri;
    this.markerIconDataUri = null;
  }
}
